import { DaymapQuery as t } from "../daymapQuery.js";
var l;
((s) => {
  class u extends t {
    constructor() {
      super(
        ["group", "filterTypes"],
        null,
        "/lms/api/group/filterTypes",
        null,
        { stale: 1e3 * 60 * 10 }
      );
    }
  }
  s.FilterTypes = u;
  class a extends t {
    constructor(e) {
      super(
        ["group", "filterValues", e.filterType],
        e,
        `/lms/api/group/filterValues?filterType=${e.filterType}`,
        null,
        { stale: 1e3 * 60 * 10 }
      );
    }
  }
  s.FilterValues = a;
  class c extends t {
    constructor(e, n) {
      super(
        ["group", "students", e.filterType, e.filter],
        e,
        `/lms/api/group/filter/${e.filterType}/${e.filter}/students`,
        null,
        { stale: 1e3 * 60 * 10, ...n }
      );
    }
  }
  s.GroupStudents = c;
  class i extends t {
    constructor() {
      super(
        ["group", "staffGroupsTypes"],
        null,
        "/lms/api/contacts/staffgroups/grouptypes",
        null,
        { stale: 1e3 * 60 * 10 }
      );
    }
  }
  s.StaffGroupsTypes = i;
  class o extends t {
    constructor(e) {
      super(
        ["usergroups", "public", e.category],
        e,
        `/lms/api/contacts/usergroups/public${e.category ? `?category=${e.category}` : ""}`,
        null,
        { stale: 1e3 * 60 * 10 }
      );
    }
  }
  s.PublicUserGroups = o;
  class p extends t {
    constructor() {
      super(
        ["securitygroups"],
        null,
        "/lms/api/permissions/securitygroups",
        null,
        { stale: 1e3 * 60 * 10 }
      );
    }
  }
  s.SecurityGroups = p;
})(l || (l = {}));
export {
  l as group
};
//# sourceMappingURL=index.js.map
